import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=2156170e&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=2156170e&prod&lang=css"
import style1 from "./noticeList.vue?vue&type=style&index=1&id=2156170e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156170e",
  null
  
)

export default component.exports